const COUNTRIES = [
  {
    name: "Afghanistan",
    code: "AF",
    dialCode: "+93",
    phoneMask: "+\\93 99 999 9999",
  },
  {
    name: "Albania",
    code: "AL",
    dialCode: "+355",
    phoneMask: "+355 999 999 999",
  },
  {
    name: "Algeria",
    code: "DZ",
    dialCode: "+213",
    phoneMask: "+213 999 99 99 99",
  },
  { name: "Andorra", code: "AD", dialCode: "+376", phoneMask: "+376 999 999" },
  {
    name: "Angola",
    code: "AO",
    dialCode: "+244",
    phoneMask: "+244 999 999 999",
  },
  {
    name: "Argentina",
    code: "AR",
    dialCode: "+54",
    phoneMask: "+54 9 9999 9999",
  },
  {
    name: "Armenia",
    code: "AM",
    dialCode: "+374",
    phoneMask: "+374 99 999999",
  },
  {
    name: "Australia",
    code: "AU",
    dialCode: "+61",
    phoneMask: "+61 9 9999 9999",
  },
  {
    name: "Austria",
    code: "AT",
    dialCode: "+43",
    phoneMask: "+43 999 999 9999",
  },
  {
    name: "Azerbaijan",
    code: "AZ",
    dialCode: "+994",
    phoneMask: "+\\9\\94 99 999 99 99",
  },
  {
    name: "Bahamas",
    code: "BS",
    dialCode: "+1",
    phoneMask: "+1 242 999 9999",
  },
  {
    name: "Bahrain",
    code: "BH",
    dialCode: "+973",
    phoneMask: "+\\973 9999 9999",
  },
  {
    name: "Bangladesh",
    code: "BD",
    dialCode: "+880",
    phoneMask: "+880 999 999 9999",
  },
  {
    name: "Barbados",
    code: "BB",
    dialCode: "+1",
    phoneMask: "+1 246 999 9999",
  },
  {
    name: "Belarus",
    code: "BY",
    dialCode: "+375",
    phoneMask: "+375 99 999 99 99",
  },
  {
    name: "Belgium",
    code: "BE",
    dialCode: "+32",
    phoneMask: "+32 999 99 99 99",
  },
  { name: "Belize", code: "BZ", dialCode: "+501", phoneMask: "+501 999 9999" },
  {
    name: "Benin",
    code: "BJ",
    dialCode: "+229",
    phoneMask: "+22\\9 99 99 99 99",
  },
  {
    name: "Bhutan",
    code: "BT",
    dialCode: "+975",
    phoneMask: "+\\975 99 99 99 99",
  },
  {
    name: "Bolivia",
    code: "BO",
    dialCode: "+591",
    phoneMask: "+5\\91 9 999 9999",
  },
  {
    name: "Bosnia and Herzegovina",
    code: "BA",
    dialCode: "+387",
    phoneMask: "+387 99 999 999",
  },
  {
    name: "Botswana",
    code: "BW",
    dialCode: "+267",
    phoneMask: "+267 99 999 999",
  },
  {
    name: "Brazil",
    code: "BR",
    dialCode: "+55",
    phoneMask: "+55 99 99999 9999",
  },
  { name: "Brunei", code: "BN", dialCode: "+673", phoneMask: "+673 999 9999" },
  {
    name: "Bulgaria",
    code: "BG",
    dialCode: "+359",
    phoneMask: "+35\\9 999 999 999",
  },
  {
    name: "Burkina Faso",
    code: "BF",
    dialCode: "+226",
    phoneMask: "+226 99 99 99 99",
  },
  {
    name: "Burundi",
    code: "BI",
    dialCode: "+257",
    phoneMask: "+257 99 99 99 99",
  },
  {
    name: "Cambodia",
    code: "KH",
    dialCode: "+855",
    phoneMask: "+855 99 999 999",
  },
  {
    name: "Cameroon",
    code: "CM",
    dialCode: "+237",
    phoneMask: "+237 99 99 99 99",
  },
  { name: "Canada", code: "CA", dialCode: "+1", phoneMask: "+1 999 999 9999" },
  {
    name: "Cape Verde",
    code: "CV",
    dialCode: "+238",
    phoneMask: "+238 999 99 99",
  },
  {
    name: "Central African Republic",
    code: "CF",
    dialCode: "+236",
    phoneMask: "+236 99 99 99 99",
  },
  {
    name: "Chad",
    code: "TD",
    dialCode: "+235",
    phoneMask: "+235 99 99 99 99",
  },
  { name: "Chile", code: "CL", dialCode: "+56", phoneMask: "+56 9 9999 9999" },
  {
    name: "China",
    code: "CN",
    dialCode: "+86",
    phoneMask: "+86 999 9999 9999",
  },
  {
    name: "Colombia",
    code: "CO",
    dialCode: "+57",
    phoneMask: "+57 9 999 9999",
  },
  {
    name: "Comoros",
    code: "KM",
    dialCode: "+269",
    phoneMask: "+26\\9 99 99 99",
  },
  {
    name: "Congo",
    code: "CG",
    dialCode: "+242",
    phoneMask: "+242 99 99 99 99",
  },
  {
    name: "Costa Rica",
    code: "CR",
    dialCode: "+506",
    phoneMask: "+506 9999 9999",
  },
  {
    name: "Croatia",
    code: "HR",
    dialCode: "+385",
    phoneMask: "+385 99 999 9999",
  },
  { name: "Cuba", code: "CU", dialCode: "+53", phoneMask: "+53 9 999 9999" },
  {
    name: "Cyprus",
    code: "CY",
    dialCode: "+357",
    phoneMask: "+357 99 999 999",
  },
  {
    name: "Czech Republic",
    code: "CZ",
    dialCode: "+420",
    phoneMask: "+420 999 999 999",
  },
  {
    name: "Denmark",
    code: "DK",
    dialCode: "+45",
    phoneMask: "+45 99 99 99 99",
  },
  {
    name: "Djibouti",
    code: "DJ",
    dialCode: "+253",
    phoneMask: "+253 99 99 99 99",
  },
  {
    name: "Dominica",
    code: "DM",
    dialCode: "+1",
    phoneMask: "+1 767 999 9999",
  },
  {
    name: "Dominican Republic",
    code: "DO",
    dialCode: "+1",
    phoneMask: "+1 809 999 9999",
  },
  {
    name: "Ecuador",
    code: "EC",
    dialCode: "+593",
    phoneMask: "+5\\93 9 999 9999",
  },
  {
    name: "Egypt",
    code: "EG",
    dialCode: "+20",
    phoneMask: "+20 999 999 9999",
  },
  {
    name: "El Salvador",
    code: "SV",
    dialCode: "+503",
    phoneMask: "+503 9999 9999",
  },
  {
    name: "Equatorial Guinea",
    code: "GQ",
    dialCode: "+240",
    phoneMask: "+240 99 99 99 99",
  },
  {
    name: "Eritrea",
    code: "ER",
    dialCode: "+291",
    phoneMask: "+2\\91 9 999 999",
  },
  {
    name: "Estonia",
    code: "EE",
    dialCode: "+372",
    phoneMask: "+372 9999 9999",
  },
  {
    name: "Eswatini",
    code: "SZ",
    dialCode: "+268",
    phoneMask: "+268 99 99 99 99",
  },
  {
    name: "Ethiopia",
    code: "ET",
    dialCode: "+251",
    phoneMask: "+251 99 999 9999",
  },
  { name: "Fiji", code: "FJ", dialCode: "+679", phoneMask: "+679 999 9999" },
  {
    name: "Finland",
    code: "FI",
    dialCode: "+358",
    phoneMask: "+358 99 999 9999",
  },
  {
    name: "France",
    code: "FR",
    dialCode: "+33",
    phoneMask: "+33 9 99 99 99 99",
  },
  {
    name: "Gabon",
    code: "GA",
    dialCode: "+241",
    phoneMask: "+241 99 99 99 99",
  },
  {
    name: "Gambia",
    code: "GM",
    dialCode: "+220",
    phoneMask: "+220 99 99 99 99",
  },
  {
    name: "Georgia",
    code: "GE",
    dialCode: "+995",
    phoneMask: "+\\9\\95 599 99 99 99",
  },
  {
    name: "Germany",
    code: "DE",
    dialCode: "+49",
    phoneMask: "+4\\9 999 999 99999",
  },
  {
    name: "Ghana",
    code: "GH",
    dialCode: "+233",
    phoneMask: "+233 99 999 9999",
  },
  {
    name: "Greece",
    code: "GR",
    dialCode: "+30",
    phoneMask: "+30 999 999 9999",
  },
  {
    name: "Grenada",
    code: "GD",
    dialCode: "+1 473",
    phoneMask: "+1 473 999 9999",
  },
  {
    name: "Guatemala",
    code: "GT",
    dialCode: "+502",
    phoneMask: "+502 9999 9999",
  },
  {
    name: "Guinea",
    code: "GN",
    dialCode: "+224",
    phoneMask: "+224 99 99 99 99",
  },
  { name: "Guyana", code: "GY", dialCode: "+592", phoneMask: "+5\\92 999 9999" },
  { name: "Haiti", code: "HT", dialCode: "+509", phoneMask: "+50\\9 9999 9999" },
  {
    name: "Honduras",
    code: "HN",
    dialCode: "+504",
    phoneMask: "+504 9999 9999",
  },
  {
    name: "Hungary",
    code: "HU",
    dialCode: "+36",
    phoneMask: "+36 9 999 9999",
  },
  {
    name: "Iceland",
    code: "IS",
    dialCode: "+354",
    phoneMask: "+354 999 9999",
  },
  { name: "India", code: "IN", dialCode: "+91", phoneMask: "+91 99999 99999" },
  {
    name: "Indonesia",
    code: "ID",
    dialCode: "+62",
    phoneMask: "+62 999 9999 9999",
  },
  { name: "Iran", code: "IR", dialCode: "+98", phoneMask: "+98 999 999 9999" },
  {
    name: "Iraq",
    code: "IQ",
    dialCode: "+964",
    phoneMask: "+\\964 999 999 9999",
  },
  {
    name: "Ireland",
    code: "IE",
    dialCode: "+353",
    phoneMask: "+353 999 999 9999",
  },
  {
    name: "Israel",
    code: "IL",
    dialCode: "+972",
    phoneMask: "+\\972 99 999 9999",
  },
  {
    name: "Italy",
    code: "IT",
    dialCode: "+39",
    phoneMask: "+3\\9 999 999 9999",
  },
  {
    name: "Jamaica",
    code: "JM",
    dialCode: "+1 876",
    phoneMask: "+1 876 999 9999",
  },
  {
    name: "Japan",
    code: "JP",
    dialCode: "+81",
    phoneMask: "+81 999 999 9999",
  },
  {
    name: "Jordan",
    code: "JO",
    dialCode: "+962",
    phoneMask: "+\\962 9 9999 9999",
  },
  {
    name: "Kazakhstan",
    code: "KZ",
    dialCode: "+7",
    phoneMask: "+7 9 999 999 999",
  },
  {
    name: "Kenya",
    code: "KE",
    dialCode: "+254",
    phoneMask: "+254 999 999 999",
  },
  {
    name: "Kuwait",
    code: "KW",
    dialCode: "+965",
    phoneMask: "+\\965 9999 9999",
  },
  {
    name: "Kyrgyzstan",
    code: "KG",
    dialCode: "+996",
    phoneMask: "+\\9\\96 999 999 999",
  },
  {
    name: "Laos",
    code: "LA",
    dialCode: "+856",
    phoneMask: "+856 99 999 9999",
  },
  {
    name: "Latvia",
    code: "LV",
    dialCode: "+371",
    phoneMask: "+371 99 999 999",
  },
  {
    name: "Lebanon",
    code: "LB",
    dialCode: "+961",
    phoneMask: "+\\961 9 999 999",
  },
  {
    name: "Lesotho",
    code: "LS",
    dialCode: "+266",
    phoneMask: "+266 99 999 999",
  },
  {
    name: "Liberia",
    code: "LR",
    dialCode: "+231",
    phoneMask: "+231 99 999 9999",
  },
  {
    name: "Libya",
    code: "LY",
    dialCode: "+218",
    phoneMask: "+218 99 999 9999",
  },
  {
    name: "Liechtenstein",
    code: "LI",
    dialCode: "+423",
    phoneMask: "+423 999 9999",
  },
  {
    name: "Lithuania",
    code: "LT",
    dialCode: "+370",
    phoneMask: "+370 999 99 999",
  },
  {
    name: "Luxembourg",
    code: "LU",
    dialCode: "+352",
    phoneMask: "+352 999 999 999",
  },
  {
    name: "Madagascar",
    code: "MG",
    dialCode: "+261",
    phoneMask: "+261 999 99 9999",
  },
  {
    name: "Malawi",
    code: "MW",
    dialCode: "+265",
    phoneMask: "+265 999 99 99 99",
  },
  {
    name: "Malaysia",
    code: "MY",
    dialCode: "+60",
    phoneMask: "+60 999 999 999",
  },
  {
    name: "Maldives",
    code: "MV",
    dialCode: "+960",
    phoneMask: "+\\960 999 9999",
  },
  {
    name: "Mali",
    code: "ML",
    dialCode: "+223",
    phoneMask: "+223 99 99 99 99",
  },
  { name: "Malta", code: "MT", dialCode: "+356", phoneMask: "+356 9999 9999" },
  {
    name: "Mauritania",
    code: "MR",
    dialCode: "+222",
    phoneMask: "+222 99 99 99 99",
  },
  {
    name: "Mexico",
    code: "MX",
    dialCode: "+52",
    phoneMask: "+52 99 9999 9999",
  },
  {
    name: "Monaco",
    code: "MC",
    dialCode: "+377",
    phoneMask: "+377 9999 9999",
  },
  {
    name: "Mongolia",
    code: "MN",
    dialCode: "+976",
    phoneMask: "+\\976 9999 9999",
  },
  {
    name: "Montenegro",
    code: "ME",
    dialCode: "+382",
    phoneMask: "+382 99 999 999",
  },
  {
    name: "Morocco",
    code: "MA",
    dialCode: "+212",
    phoneMask: "+212 99 9999 9999",
  },
  {
    name: "Mozambique",
    code: "MZ",
    dialCode: "+258",
    phoneMask: "+258 99 999 9999",
  },
  {
    name: "Myanmar",
    code: "MM",
    dialCode: "+95",
    phoneMask: "+\\95 9 999 9999",
  },
  {
    name: "Namibia",
    code: "NA",
    dialCode: "+264",
    phoneMask: "+264 999 999 999",
  },
  {
    name: "Nepal",
    code: "NP",
    dialCode: "+977",
    phoneMask: "+\\977 9 9999 9999",
  },
  {
    name: "Netherlands",
    code: "NL",
    dialCode: "+31",
    phoneMask: "+31 99 999 9999",
  },
  {
    name: "New Zealand",
    code: "NZ",
    dialCode: "+64",
    phoneMask: "+64 9 999 9999",
  },
  {
    name: "Nicaragua",
    code: "NI",
    dialCode: "+505",
    phoneMask: "+505 9999 9999",
  },
  {
    name: "Niger",
    code: "NE",
    dialCode: "+227",
    phoneMask: "+227 99 99 99 99",
  },
  {
    name: "Nigeria",
    code: "NG",
    dialCode: "+234",
    phoneMask: "+234 99 999 9999",
  },
  { name: "Norway", code: "NO", dialCode: "+47", phoneMask: "+47 999 99 999" },
  { name: "Oman", code: "OM", dialCode: "+968", phoneMask: "+\\968 9999 9999" },
  {
    name: "Pakistan",
    code: "PK",
    dialCode: "+92",
    phoneMask: "+\\92 999 999 9999",
  },
  {
    name: "Palestine",
    code: "PS",
    dialCode: "+970",
    phoneMask: "+\\970 99 999 9999",
  },
  { name: "Panama", code: "PA", dialCode: "+507", phoneMask: "+507 999 9999" },
  {
    name: "Paraguay",
    code: "PY",
    dialCode: "+595",
    phoneMask: "+5\\95 99 999 999",
  },
  { name: "Peru", code: "PE", dialCode: "+51", phoneMask: "+51 9 999 9999" },
  {
    name: "Philippines",
    code: "PH",
    dialCode: "+63",
    phoneMask: "+63 999 999 9999",
  },
  {
    name: "Poland",
    code: "PL",
    dialCode: "+48",
    phoneMask: "+48 999 999 999",
  },
  {
    name: "Portugal",
    code: "PT",
    dialCode: "+351",
    phoneMask: "+351 999 999 999",
  },
  { name: "Qatar", code: "QA", dialCode: "+974", phoneMask: "+\\974 9999 9999" },
  {
    name: "Romania",
    code: "RO",
    dialCode: "+40",
    phoneMask: "+40 999 999 999",
  },
  {
    name: "Russia",
    code: "RU",
    dialCode: "+7",
    phoneMask: "+7 999 999 99 99",
  },
  {
    name: "Rwanda",
    code: "RW",
    dialCode: "+250",
    phoneMask: "+250 99 999 9999",
  },
  {
    name: "Saudi Arabia",
    code: "SA",
    dialCode: "+966",
    phoneMask: "+\\966 9 9999 9999",
  },
  {
    name: "Senegal",
    code: "SN",
    dialCode: "+221",
    phoneMask: "+221 99 999 9999",
  },
  {
    name: "Serbia",
    code: "RS",
    dialCode: "+381",
    phoneMask: "+381 99 999 9999",
  },
  {
    name: "Seychelles",
    code: "SC",
    dialCode: "+248",
    phoneMask: "+248 9 99 99 99",
  },
  {
    name: "Sierra Leone",
    code: "SL",
    dialCode: "+232",
    phoneMask: "+232 99 999 999",
  },
  {
    name: "Singapore",
    code: "SG",
    dialCode: "+65",
    phoneMask: "+65 999 99999",
  },
  {
    name: "Slovakia",
    code: "SK",
    dialCode: "+421",
    phoneMask: "+421 999 999 999",
  },
  {
    name: "Slovenia",
    code: "SI",
    dialCode: "+386",
    phoneMask: "+386 99 999 999",
  },
  {
    name: "Somalia",
    code: "SO",
    dialCode: "+252",
    phoneMask: "+252 99 999 999",
  },
  {
    name: "South Africa",
    code: "ZA",
    dialCode: "+27",
    phoneMask: "+27 99 999 9999",
  },
  {
    name: "South Korea",
    code: "KR",
    dialCode: "+82",
    phoneMask: "+82 9 9999 9999",
  },
  { name: "Spain", code: "ES", dialCode: "+34", phoneMask: "+34 999 999 999" },
  {
    name: "Sri Lanka",
    code: "LK",
    dialCode: "+94",
    phoneMask: "+\\94 99 999 9999",
  },
  {
    name: "Sudan",
    code: "SD",
    dialCode: "+249",
    phoneMask: "+24\\9 99 999 9999",
  },
  {
    name: "Suriname",
    code: "SR",
    dialCode: "+597",
    phoneMask: "+5\\97 999 9999",
  },
  {
    name: "Sweden",
    code: "SE",
    dialCode: "+46",
    phoneMask: "+46 99 999 9999",
  },
  {
    name: "Switzerland",
    code: "CH",
    dialCode: "+41",
    phoneMask: "+41 99 999 99 99",
  },
  {
    name: "Syria",
    code: "SY",
    dialCode: "+963",
    phoneMask: "+\\963 99 999 9999",
  },
  {
    name: "Taiwan",
    code: "TW",
    dialCode: "+886",
    phoneMask: "+886 9 999 9999",
  },
  {
    name: "Tajikistan",
    code: "TJ",
    dialCode: "+992",
    phoneMask: "+\\9\\92 99 999 9999",
  },
  {
    name: "Tanzania",
    code: "TZ",
    dialCode: "+255",
    phoneMask: "+255 99 999 9999",
  },
  {
    name: "Thailand",
    code: "TH",
    dialCode: "+66",
    phoneMask: "+66 99 999 9999",
  },
  {
    name: "Togo",
    code: "TG",
    dialCode: "+228",
    phoneMask: "+228 99 99 99 99",
  },
  { name: "Tonga", code: "TO", dialCode: "+676", phoneMask: "+676 999 9999" },
  {
    name: "Trinidad and Tobago",
    code: "TT",
    dialCode: "+1 868",
    phoneMask: "+1 868 999 9999",
  },
  {
    name: "Tunisia",
    code: "TN",
    dialCode: "+216",
    phoneMask: "+216 99 999 999",
  },
  {
    name: "Turkey",
    code: "TR",
    dialCode: "+90",
    phoneMask: "+\\90 999 999 9999",
  },
  {
    name: "Turkmenistan",
    code: "TM",
    dialCode: "+993",
    phoneMask: "+\\9\\93 99 999 999",
  },
  {
    name: "Uganda",
    code: "UG",
    dialCode: "+256",
    phoneMask: "+256 999 999 999",
  },
  {
    name: "Ukraine",
    code: "UA",
    dialCode: "+380",
    phoneMask: "+380 99 999 9999",
  },
  {
    name: "United Arab Emirates",
    code: "AE",
    dialCode: "+971",
    phoneMask: "+\\971 9 999 9999",
  },
  {
    name: "United Kingdom",
    code: "GB",
    dialCode: "+44",
    phoneMask: "+44 99 9999 9999",
  },
  {
    name: "United States",
    code: "US",
    dialCode: "+1",
    phoneMask: "+1 999 999 9999",
  },
  {
    name: "Uruguay",
    code: "UY",
    dialCode: "+598",
    phoneMask: "+5\\98 99 999 999",
  },
  {
    name: "Uzbekistan",
    code: "UZ",
    dialCode: "+998",
    phoneMask: "+\\9\\98 99 999 99 99",
  },
  {
    name: "Vanuatu",
    code: "VU",
    dialCode: "+678",
    phoneMask: "+678 99 999 999",
  },
  {
    name: "Vatican City",
    code: "VA",
    dialCode: "+39",
    phoneMask: "+3\\9 06 698 99999",
  },
  {
    name: "Venezuela",
    code: "VE",
    dialCode: "+58",
    phoneMask: "+58 999 999 9999",
  },
  {
    name: "Vietnam",
    code: "VN",
    dialCode: "+84",
    phoneMask: "+84 99 999 9999",
  },
  { name: "Yemen", code: "YE", dialCode: "+967", phoneMask: "+\\967 9 999 999" },
  {
    name: "Zambia",
    code: "ZM",
    dialCode: "+260",
    phoneMask: "+260 99 999 9999",
  },
  {
    name: "Zimbabwe",
    code: "ZW",
    dialCode: "+263",
    phoneMask: "+263 99 999 9999",
  },
];

export const COUNTRIES_WITH_FLAGS = COUNTRIES.map((country) => ({
  ...country,
  flag: `https://flagcdn.com/48x36/${country.code.toLowerCase()}.png`,
}));
